import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * MedicalCross icon
 *
 * @category Medical
 */
const MedicalCross = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M26.652 12.96c-.83-.76-1.88-.78-2.86-.76-1.36-.05-3.33.1-3.89-.08-.25-1.31.08-4.01-.15-5.35-.26-1.71-2.04-2.45-3.62-2.27-.94 0-1.83-.06-2.65.47-1.15.77-1.32 1.9-1.27 3.26-.03.92.06 3.05-.04 3.84-.06.16-.29.13-.77.13-2.55.21-5.75-.88-6.73 1.95-.92 6.29 1.74 5.68 6.73 5.65.91 0 .81-.06.81 1.03.06 1.39-.13 3.24.11 4.57.37 1.74 2.24 2.26 3.8 2.1.93.01 1.8.01 2.57-.58 1.72-1.36.94-3.62 1.11-5.6.11-1.19-.42-1.6.81-1.52 1.91-.21 4.94.7 6.31-1.11.53-.72.58-1.45.58-2.26 0-1.26.12-2.4-.76-3.36l-.12-.12zm-.2 4.39c-.87 2.64-5.26.86-7.14 1.6-.87.59-.35 2.6-.48 3.67.03 1.45.22 3.57-1.68 3.81-1.19.1-2.95.26-3.57-.8-.67-1.32-.24-3-.36-4.43 0-.69.09-1.71-.26-2.08-.15-.18-.37-.26-.65-.29-1.22-.07-3.35 0-4.42-.03-.78.03-1.69-.22-2.08-.97-1.59-6.15 2.75-4.29 6.67-4.68.77-.18.77-.97.76-1.85-.06-1.07.01-2.02-.03-3.04-.02-.8 0-1.65.66-2.22.78-.68 1.86-.53 2.82-.52 2.87 0 2.01 3.39 2.13 5.28 0 1.17-.22 2.47 1.25 2.4 3.66.2 7.18-1.25 6.41 4.01l-.04.15z"
        />
      </svg>
    );
  }
);

MedicalCross.displayName = 'MedicalCross';

export { MedicalCross };
